<template>
  <div class="bg-box">
    <div class="display_wrapper">
      <div class="title">{{count}}秒后自动跳转</div>
      <div class="subtitle">即将跳转到下载页面</div>
      <img class="icon" style="height: auto; margin-top: 1rem;" src='../../../../assets/wutong/click.png' alt="logo" />
      <div @click="goDownload" class="btn">
        立即前往下载
      </div>
      <div class="subtitle">若未自动跳转，请点击按钮</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppRegister',
  data() {
    return {
      timer: null,
      count: 3
    }
  },
  mounted() {
    this.startCountdown();
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    startCountdown() {
      this.timer = setInterval(() => {
        this.count--;
        if (this.count <= 0) {
          clearInterval(this.timer);
          this.goDownload();
        }
      }, 1000);
    },
    goDownload() {
      this.$router.push('/app_download');
    }
  }
}
</script>

<style scoped>
.bg-box {
  background-image: url('../../../../assets/wutong/newbg.jpg');
  background-size: 100% 100%;
  background-position: top center;
  background-repeat: no-repeat;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
}
.display_wrapper{
  margin-top: 28vh;
  background-color: #fff;
  border-radius: 14px;
  width: 90%;
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;
  color: #222;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title{
    font-size: 17px;
    font-weight: 500;
  }
  .subtitle{
    font-size: 12px;
    color: #666;
    /* margin-top: 0.5rem; */
  }
  .icon{
    width: 138px;
    height: auto;
    margin: 20px 0;
  }
  .btn{
    width: 100%;
    max-width: 400px;
    background: #3678FF;
    border-radius: 11px;
    color: #fff;
    font-size: 17px;
    text-align: center;
    padding: 0.8rem 0;
    cursor: pointer;
    user-select: none;
    color: #fff;
    margin-bottom: 13px;
  }
}
</style>
